module.exports = {
	model: {
		info: ''
	},

	hooks: {
		showColumnDescription: function($element, options){
			options = options || {};

			if(options.info){
				this.model.info = options.info;
				this.refresh();
			}
		},

		hideColumnDescription: function($element, options){
			this.model.info = '';
			this.refresh();
		}
	}
}